import React from 'react';
import { TONES, toneFor, labelFor } from './tokens';

/**
 * Status pill.
 *
 * Replaces six near-identical badge factories (RateCards, TrunkManagement,
 * DIDManagement, CallHistory, ActiveCalls, plus TrunkManagement's separate
 * registration badge). They shared a byte-identical return statement but each
 * owned a partial, drifting colour map — so yellow meant "pending" on one
 * screen and "draft" on another.
 *
 * The tone can be inferred from the status string or set explicitly.
 */
const StatusPill = ({ status, tone, icon: Icon, label, size = 'md', className = '' }) => {
  const t = TONES[tone || toneFor(status)] || TONES.neutral;
  const sizing = size === 'sm' ? 'px-1.5 py-0.5 text-[11px] gap-1' : 'px-2 py-0.5 text-xs gap-1.5';

  return (
    <span
      className={`inline-flex items-center ${sizing} font-medium rounded-full ring-1 ring-inset whitespace-nowrap ${t.pill} ${className}`}
    >
      {Icon && <Icon className={size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5'} />}
      {label || labelFor(status)}
    </span>
  );
};

export default StatusPill;
